import styled, { keyframes } from 'styled-components';
import { OVERLAY_CONFIG } from 'styles/overlayConfig';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${OVERLAY_CONFIG.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  pointer-events: ${(props) => (props.$show ? 'auto' : 'none')};
  transition: opacity ${OVERLAY_CONFIG.fadeInDuration}
    ${OVERLAY_CONFIG.fadeInEasing};
`;

export const ModalContent = styled.div`
  background: #1a1a1a;
  border: 3px solid ${(props) => props.$borderColor || '#ff3366'};
  border-radius: 16px;
  padding: 40px 30px;
  max-width: 450px;
  width: 90%;
  text-align: center;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transform: ${(props) => (props.$show ? 'scale(1)' : 'scale(0.95)')};
  transition:
    opacity ${OVERLAY_CONFIG.fadeInDuration} ${OVERLAY_CONFIG.fadeInEasing},
    transform ${OVERLAY_CONFIG.fadeInDuration} ${OVERLAY_CONFIG.fadeInEasing};
  animation: ${(props) => (props.$show ? fadeIn : 'none')}
    ${OVERLAY_CONFIG.fadeInDuration} ${OVERLAY_CONFIG.fadeInEasing};

  @media (max-width: 768px) {
    padding: 30px 20px;
    max-width: 90%;
  }
`;

export const NotificationIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
  filter: drop-shadow(0 0 10px ${(props) => props.$color || '#ff3366'});

  @media (max-width: 768px) {
    font-size: 48px;
    margin-bottom: 15px;
  }
`;

export const ModalTitle = styled.h2`
  color: #ffffff;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 20px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 15px;
  }
`;

export const ModalText = styled.p`
  color: #ffffff;
  font-size: 16px;
  line-height: 1.6;
  margin: 0 0 10px 0;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 30px;

  @media (max-width: 768px) {
    margin-top: 25px;
    gap: 10px;
  }
`;

export const ModalButton = styled.button`
  background-color: ${(props) => props.$color || '#ff3366'};
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 16px 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
    filter: brightness(1.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    padding: 14px 28px;
    font-size: 16px;
  }
`;

export const MaybeLaterButton = styled.button`
  background-color: transparent;
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.05);
  }

  @media (max-width: 768px) {
    padding: 12px 28px;
    font-size: 14px;
  }
`;
